module.exports = __webpack_public_path__ + "img/bottom-bg.3f49bed8.png";